// extracted by mini-css-extract-plugin
module.exports = {"imageUpload":"jgp-1aUsW","icon":"jgp-1SLhi"};